export const TIGHT_DECISION_EURO = 0.75;
export const MIN_WORTHWHILE_SAVING_EURO = 1;

export function totalCostForLitres(station, litres) {
  if (!station || !Number.isFinite(litres) || litres <= 0) return null;
  return station.pumpPrice * litres + station.estimate.travelCost;
}

export function compareTotalCost(station, bestStation) {
  if (!station || !bestStation) return null;
  const litres = bestStation.estimate.purchasedLitres;
  const stationCost = totalCostForLitres(station, litres);
  const bestCost = totalCostForLitres(bestStation, litres);
  return Number.isFinite(stationCost) && Number.isFinite(bestCost) ? stationCost - bestCost : null;
}

export function compareStationToBest(station, bestStation) {
  if (!station || !bestStation || station.id === bestStation.id) return null;
  const litres = bestStation.estimate.purchasedLitres;
  const pumpDifference = (station.pumpPrice - bestStation.pumpPrice) * litres;
  const travelDifference = station.estimate.travelCost - bestStation.estimate.travelCost;
  const totalDifference = compareTotalCost(station, bestStation);
  if (![pumpDifference, travelDifference, totalDifference].every(Number.isFinite)) return null;
  return {
    litres,
    pumpDifference,
    travelDifference,
    totalDifference,
    travelKmDifference: station.estimate.travelKm - bestStation.estimate.travelKm,
    effectivePriceDifference: station.estimate.effectivePrice - bestStation.estimate.effectivePrice,
  };
}

export function buildDecisionInsights(ranked) {
  const best = ranked?.[0];
  const next = ranked?.[1];
  if (!best) return null;

  const savingsVsNext = next ? Math.max(0, compareTotalCost(next, best)) : null;
  const closestTravel = [...ranked].sort((left, right) => left.estimate.travelKm - right.estimate.travelKm)[0];
  const savingsVsClosest = closestTravel && closestTravel.id !== best.id
    ? Math.max(0, compareTotalCost(closestTravel, best))
    : null;
  const extraTravelKm = closestTravel && closestTravel.id !== best.id
    ? Math.max(0, best.estimate.travelKm - closestTravel.estimate.travelKm)
    : 0;

  return {
    next,
    savingsVsNext,
    tight: Number.isFinite(savingsVsNext) && savingsVsNext <= TIGHT_DECISION_EURO,
    closestTravel,
    savingsVsClosest,
    extraTravelKm,
    smallSaving: Number.isFinite(savingsVsClosest)
      && savingsVsClosest > 0
      && savingsVsClosest < MIN_WORTHWHILE_SAVING_EURO
      && extraTravelKm >= 1,
  };
}
